/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Faq_3_QInputs */

const en_nfp_faq_3_q = /** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can we host private study groups or congregation chats?`)
};

const es_nfp_faq_3_q = /** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Podemos alojar grupos de estudio privados?`)
};

const fr_nfp_faq_3_q = /** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouvons-se héberger des groupes d'étude privés ou des discussions de congrégation ?`)
};

const de_nfp_faq_3_q = /** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Können wir private Lerngruppen oder Gemeinde-Chats hosten?`)
};

const id_nfp_faq_3_q = /** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkah kami menyelenggarakan grup belajar pribadi atau obrolan jemaat?`)
};

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const ja_nfp_faq_3_q = en_nfp_faq_3_q;

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const zh_nfp_faq_3_q = en_nfp_faq_3_q;

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const ar_nfp_faq_3_q = en_nfp_faq_3_q;

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const it_nfp_faq_3_q = en_nfp_faq_3_q;

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const ru_nfp_faq_3_q = en_nfp_faq_3_q;

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const pt_nfp_faq_3_q = en_nfp_faq_3_q;

/** @type {(inputs: Nfp_Faq_3_QInputs) => LocalizedString} */
const ko_nfp_faq_3_q = en_nfp_faq_3_q;

/**
* | output |
* | --- |
* | "Can we host private study groups or congregation chats?" |
*
* @param {Nfp_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_faq_3_q = /** @type {((inputs?: Nfp_Faq_3_QInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Faq_3_QInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_faq_3_q(inputs)
	if (locale === "es") return es_nfp_faq_3_q(inputs)
	if (locale === "fr") return fr_nfp_faq_3_q(inputs)
	if (locale === "de") return de_nfp_faq_3_q(inputs)
	if (locale === "ja") return ja_nfp_faq_3_q(inputs)
	if (locale === "zh") return zh_nfp_faq_3_q(inputs)
	if (locale === "ar") return ar_nfp_faq_3_q(inputs)
	if (locale === "id") return id_nfp_faq_3_q(inputs)
	if (locale === "it") return it_nfp_faq_3_q(inputs)
	if (locale === "ru") return ru_nfp_faq_3_q(inputs)
	if (locale === "pt") return pt_nfp_faq_3_q(inputs)
	return ko_nfp_faq_3_q(inputs)
});